import React, {useState} from 'react';
import {EnumAuthenticationMode} from "../Authentication";
import styles from './Registration.module.css';
import AuthenticationInput from "../../Utils/Inputs/AuthenticationInput/AuthenticationInput";
import Buttons, {EnumColors} from "../../Utils/Buttons/Buttons/Buttons";
import {useAppDispatch, useAppSelector} from "../../../hooks/redux";
import {getLanguage} from "../../../store/selectors/appSelector";
import {UIText} from "../../../enums/UIText/UIText";
import {toast} from "react-toastify";
import {registrationThunk} from "../../../store/actions/AuthActions";
import {UXToast} from "../../../enums/UXText/UXToast";
import {getTextByLanguage} from "../../../enums/utils/getTextByLanguage";

interface IProps {
    setAuthenticationMode: (props: EnumAuthenticationMode) => void
}

const Registration = ({setAuthenticationMode}: IProps) => {

    const language = useAppSelector(getLanguage)

    const [email, setEmail] = useState<string>('')
    const [password, setPassword] = useState<string>('')
    const [repeatPassword, setRepeatPassword] = useState<string>('')

    const dispatch = useAppDispatch()

    const registrationHandler = () => {
        if (email && password && repeatPassword) {
            if(password.trim().length < 6){
                toast.warning(getTextByLanguage(UXToast.registration.passwordsTooShort, language))
            }else if (password === repeatPassword) {
                dispatch(registrationThunk({
                    registerData: {
                        email,
                        password
                    },
                    setAuthenticationMode: setAuthenticationMode
                }))
            } else {
                toast.warning(getTextByLanguage(UXToast.registration.passwordsNotMatch, language))
            }
        } else {
            toast.info(getTextByLanguage(UXToast.registration.requires, language))
        }
    }

    const onKeyEnterHandler = (e: KeyboardEvent) => {
        if (e.key === 'Enter') {
            registrationHandler()
        }
    }


    const toLoginHandler = () => {
        setAuthenticationMode(EnumAuthenticationMode.login)
    }
    return (
        <div className={styles.registrationWrapper} onKeyUp={() => onKeyEnterHandler}>

            <AuthenticationInput
                type={'email'}
                placeholder={getTextByLanguage(UIText.authentication.inputsPlaceholders.email, language)}
                onChange={(e) => setEmail(e.target.value)}
            />
            <AuthenticationInput
                type={'password'}
                placeholder={getTextByLanguage(UIText.authentication.inputsPlaceholders.password, language)}
                onChange={(e) => setPassword(e.target.value)}
            />
            <AuthenticationInput
                type={'password'}
                placeholder={getTextByLanguage(UIText.authentication.inputsPlaceholders.repeatPassword, language)}
                onChange={(e) => setRepeatPassword(e.target.value)}
            />
            <div className={styles.registrationButtons}>
                <Buttons color={EnumColors.white}
                         onClick={registrationHandler}>
                    {getTextByLanguage(UIText.authentication.buttons.continue, language)}
                </Buttons>
                <Buttons color={EnumColors.white}
                         onClick={toLoginHandler}>
                    {getTextByLanguage(UIText.authentication.buttons.haveAccount, language)}
                </Buttons>
            </div>

        </div>
    );
};

export default Registration;